import React from 'react';
import { BsFillExclamationCircleFill } from 'react-icons/bs';

export { default as sectionTypes } from './sectionTypes';

export const FTO_STATUS = Object.freeze({
    DRAFT: 3,
    SUBMITTED: 4
});

export const ValidationErrorMessage = ({ className }) => {
    return (
        <div className={className}>            
            <p className='text-red-600 text-xs flex items-center'>
                <BsFillExclamationCircleFill className='mr-2 mb-0.5' />
                You have not provided all the required information in this section.
            </p>
        </div>
    );
};